export default "__VITE_ASSET__e1a27423__"